'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iterateOverContactMatches = exports.getTypeFromHref = undefined;

var _ = require('./');

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _findKey = require('lodash/findKey');

var _findKey2 = _interopRequireDefault(_findKey);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypeFromHref = exports.getTypeFromHref = function getTypeFromHref(href) {
  return (0, _findKey2.default)(_.protocolByContactType, function (value) {
    return (0, _startsWith2.default)(href, value);
  });
};

var contactMatchSelector = '[data-contact-match=true]';

var iterateOverContactMatches = exports.iterateOverContactMatches = function iterateOverContactMatches(_ref) {
  var callback = _ref.callback,
      DOMElement = _ref.DOMElement;

  var contactMatches = DOMElement.querySelectorAll(contactMatchSelector);
  // IE does not support forEach on a NodeList
  (0, _forEach2.default)(contactMatches, function (element) {
    var href = element.getAttribute('href');

    if (href) {
      var type = getTypeFromHref(href);
      callback(type, element);
    }
  });
};